export default __webpack_public_path__ + "static/media/logo_sieda.8b36953c.png";